unit View.Consulta_Sistema;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Lists, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, WEBLib.Grids, WEBLib.DBCtrls, Grid.Plugins,
  WEBLib.WebCtrls, UHelperServer, UConstantes, System.StrUtils, UUtils;

type
  TConsulta_Sistema = class(TForm)
    tblConsulta: TDBTableControl;
    edtConsulta: TEdit;
    tmrConsulta: TTimer;
    lblConsultaTopo: TLabel;
    lblSubConsulta: TLabel;
    btnFecharConsulta: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure tblConsultaGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edtConsultaKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edtConsultaKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cdsConsultaAfterOpen(DataSet: TDataSet);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure tblConsultaGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblConsultaClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure WebFormKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnFecharConsultaClick(Sender: TObject);
  private
    FCdsConsulta : TXDataWebDataSet;
    FDtsConsulta : TDataSource;

    procedure ConfigurarCds;
    procedure RealizarConsulta;
    procedure ConfigurarTabela;
    function GetPrefixoConsulta : string;
    procedure FecharTela;
  public
    FTituloConsulta,
    FConsultaTabela : string;
    FEdit : TEdit;
    FIgnorarVazio : Boolean;
  protected procedure LoadDFMValues; override; end;

var
  Consulta_Sistema: TConsulta_Sistema;

implementation

uses
  ConnectionModule;

{$R *.dfm}

procedure TConsulta_Sistema.btnFecharConsultaClick(Sender: TObject);
begin
  FecharTela;
end;

procedure TConsulta_Sistema.cdsConsultaAfterOpen(DataSet: TDataSet);
begin
  if Trim(edtConsulta.Text) <> '' then
    tblConsulta.Visible := True
  else
  begin
    if tblConsulta.Visible then
      tblConsulta.Visible := False;
  end;
end;

procedure TConsulta_Sistema.ConfigurarCds;
var
  lStringField: TStringField;
  lIntegerField : TIntegerField;
begin
  FCdsConsulta.FieldDefs.Clear;

  case IndexStr(UpperCase(FConsultaTabela), ['CIDADE', 'ALIADO', 'PARCEIROS', 'UF',
    'FS_PROD_CARACTERISTICAS', 'CLIENTES', 'SEGMENTOS', 'FORNECEDORES']) of
    0:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'Nome';
      lStringField.DataSet := FCdsConsulta;

      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'ID';
      lIntegerField.DataSet := FCdsConsulta;

      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'uf.Sigla';
      lStringField.DataSet := FCdsConsulta;
    end;
    1:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'Nome_Fantasia';
      lStringField.DataSet := FCdsConsulta;

      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'Id';
      lIntegerField.DataSet := FCdsConsulta;

      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'CNPJ';
      lStringField.DataSet := FCdsConsulta;

      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'cidade.Nome';
      lStringField.DataSet := FCdsConsulta;

      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'cidade.uf.Sigla';
      lStringField.DataSet := FCdsConsulta;
    end;
    2:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'nome';
      lStringField.DataSet := FCdsConsulta;


      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'id';
      lIntegerField.DataSet := FCdsConsulta;

      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'cidade.Nome';
      lStringField.DataSet := FCdsConsulta;
    end;
    3:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'Sigla';
      lStringField.DataSet := FCdsConsulta;


      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'ID';
      lIntegerField.DataSet := FCdsConsulta;
    end;
    4:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'tipo';
      lStringField.DataSet := FCdsConsulta;

      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'id';
      lIntegerField.DataSet := FCdsConsulta;
    end;
    5, 7:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'razao_social_nome';
      lStringField.DataSet := FCdsConsulta;

      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'id';
      lIntegerField.DataSet := FCdsConsulta;
    end;
    6:
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'Nome';
      lStringField.DataSet := FCdsConsulta;

      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'Id';
      lIntegerField.DataSet := FCdsConsulta;
    end
    else
    begin
      lStringField := TStringField.Create(FCdsConsulta);
      lStringField.FieldName := 'nome';
      lStringField.DataSet := FCdsConsulta;


      lIntegerField := TIntegerField.Create(FCdsConsulta);
      lIntegerField.FieldName := 'id';
      lIntegerField.DataSet := FCdsConsulta;
    end;
  end;
end;

procedure TConsulta_Sistema.ConfigurarTabela;
begin
  tblConsulta.Columns.Clear;
  with tblConsulta.Columns.Add do
  begin
    case IndexStr(UpperCase(FConsultaTabela), ['CIDADE', 'ALIADO', 'UF', 'FS_PROD_CARACTERISTICAS',
      'CLIENTES', 'FORNECEDORES']) of
      0 : DataField := 'Nome';
      1 : DataField := 'Nome_Fantasia';
      2 : DataField := 'Sigla';
      3 : DataField := 'tipo';
      4, 5 : DataField := 'razao_social_nome';
      else DataField := 'nome';
    end;
  end;
end;

procedure TConsulta_Sistema.edtConsultaKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if tblConsulta.Visible then
    tblConsulta.Visible := False;
end;

procedure TConsulta_Sistema.edtConsultaKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TConsulta_Sistema.FecharTela;
begin
  if not FIgnorarVazio then
  begin
    FEdit.Text := '';
    FEdit.Tag := 0;
  end;

  Close;
end;

function TConsulta_Sistema.GetPrefixoConsulta: string;
begin
  case IndexStr(UpperCase(FConsultaTabela), ['CIDADE', 'ALIADO', 'PARCEIROS', 'UF',
    'FS_PROD_CARACTERISTICAS', 'CLIENTES', 'FORNECEDORES']) of
    0: Result := '$select=Nome,ID,uf/Sigla&$expand=uf';
    1:
    begin
      Result := '$select=Nome_Fantasia, Id, CNPJ, cidade/Nome, cidade/uf/Sigla' +
        '&$expand=cidade, cidade/uf';
    end;
    2: Result := '$select=nome, id, cidade/Nome&$expand=cidade';
    3: Result := '$select=Sigla, ID';
    4: Result := '$select=tipo, id';
    5, 6: Result := '$select=razao_social_nome, id';
    else Result := '$select=nome, id';
  end;
end;

procedure TConsulta_Sistema.RealizarConsulta;
var
  lFilter : string;
begin
  if Trim(edtConsulta.Text) <> '' then
  begin
    case IndexStr(UpperCase(FConsultaTabela), ['CIDADE', 'ALIADO', 'UF', 'FS_PROD_CARACTERISTICAS',
      'CLIENTES', 'FORNECEDORES']) of
      0 : lFilter := GetPrefixoConsulta + '&$filter=contains(Nome, '+QuotedStr(edtConsulta.Text)+')';
      1 :
      begin
        lFilter := edtConsulta.Text;
        lFilter := lFilter.Replace('/', '');
        lFilter := lFilter.Replace('.', '');
        lFilter := lFilter.Replace('-', '');
        lFilter := GetPrefixoConsulta + '&$filter=contains(Nome_Fantasia, '+QuotedStr(lFilter)+') or ' +
          'contains(Id, '+QuotedStr(lFilter)+') or contains(CNPJ, '+QuotedStr(lFilter)+')';
      end;
      2 : lFilter := GetPrefixoConsulta + '&$filter=contains(Sigla, '+QuotedStr(edtConsulta.Text)+')';
      3 : lFilter := GetPrefixoConsulta + '&$filter=contains(tipo, '+QuotedStr(edtConsulta.Text)+')';
      4, 5 :
      begin
        lFilter := edtConsulta.Text;
        lFilter := lFilter.Replace('/', '');
        lFilter := lFilter.Replace('.', '');
        lFilter := lFilter.Replace('-', '');
        lFilter := GetPrefixoConsulta + '&$filter=contains(razao_social_nome, '+QuotedStr(lFilter)+') or ' +
          'contains(codigo_interno, '+QuotedStr(lFilter)+') or contains(cpf_cnpj, '+QuotedStr(lFilter)+')' +
          'or contains(nome_fantasia_apelido, '+QuotedStr(lFilter)+')';
      end;
      else lFilter := GetPrefixoConsulta + '&$filter=contains(nome, '+QuotedStr(edtConsulta.Text)+')';
    end;
  end;

  TUtils.ChamarDivLoading;
  FCdsConsulta.DisableControls;

  try
    FCdsConsulta.Close;
    FCdsConsulta.QueryString := lFilter;
    FCdsConsulta.Load;
  finally
    FCdsConsulta.EnableControls;
    TUtils.OcultarDivLoading;
  end;
end;

procedure TConsulta_Sistema.tblConsultaClickCell(Sender: TObject; ACol,
  ARow: Integer);
begin
   tblConsulta.DataSource.DataSet.RecNo := ARow;
  case IndexStr(UpperCase(FConsultaTabela), ['CIDADE', 'ALIADO', 'UF', 'FS_PROD_CARACTERISTICAS',
    'CLIENTES', 'FORNECEDORES']) of
    0:
    begin
      FEdit.Text := FCdsConsulta.FieldByName('Nome').AsString + ' - ' + FCdsConsulta.FieldByName('uf.Sigla').AsString;
      FEdit.Tag := FCdsConsulta.FieldByName('ID').AsInteger;
    end;
    1:
    begin
      FEdit.Text := FCdsConsulta.FieldByName('Nome_Fantasia').AsString;
      FEdit.Tag := FCdsConsulta.FieldByName('Id').AsInteger;
    end;
    2:
    begin
      FEdit.Text := FCdsConsulta.FieldByName('Sigla').AsString;
      FEdit.Tag := FCdsConsulta.FieldByName('ID').AsInteger;
    end;
    3:
    begin
      FEdit.Text := FCdsConsulta.FieldByName('tipo').AsString;
      FEdit.Tag := FCdsConsulta.FieldByName('id').AsInteger;
    end;
    4, 5:
    begin
      FEdit.Text := FCdsConsulta.FieldByName('razao_social_nome').AsString;
      FEdit.Tag := FCdsConsulta.FieldByName('id').AsInteger;
    end;
    else
    begin
      FEdit.Text := FCdsConsulta.FieldByName('nome').AsString;
      FEdit.Tag := FCdsConsulta.FieldByName('id').AsInteger;
    end;
  end;

  tmrConsulta.Enabled := False;
  Close;
end;

procedure TConsulta_Sistema.tblConsultaGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'd-none'
  else
    AClassName := 'facil_font facil_font_size_input';
end;

procedure TConsulta_Sistema.tblConsultaGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(UpperCase(FConsultaTabela), ['CIDADE', 'PARCEIROS', 'ALIADO']) of
      0: AValue := UpperCase(AValue + ' - ' + FCdsConsulta.FieldByName('uf.Sigla').AsString);
      1: AValue := UpperCase(AValue + ' (' + FCdsConsulta.FieldByName('cidade.Nome').AsString) + ')';
      2:
      begin
        AValue := FCdsConsulta.FieldByName('Id').AsString + ' - ' + AValue + ' - ' +
          TUtils.FormatarCnpj_Cpf(FCdsConsulta.FieldByName('CNPJ').AsString) + ' - ' +
            FCdsConsulta.FieldByName('cidade.Nome').AsString + '/' + FCdsConsulta.FieldByName('cidade.uf.Sigla').AsString;
      end;
    end;

    AValue := AValue.ToUpper;
  end;
end;

procedure TConsulta_Sistema.tmrConsultaTimer(Sender: TObject);
begin
  RealizarConsulta;

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TConsulta_Sistema.WebFormCloseQuery(Sender: TObject;
  var CanClose: Boolean);
begin
  if CanClose then
  begin
    if Assigned(FDtsConsulta) then
      FreeAndNil(FDtsConsulta);

    if Assigned(FCdsConsulta) then
      FreeAndNil(FCdsConsulta);

    asm
      document.body.style.overflow = 'auto';
    end;
  end;
end;

procedure TConsulta_Sistema.WebFormKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  case Key of
    VK_ESCAPE :
    begin
      FecharTela;
    end
  end;
end;

procedure TConsulta_Sistema.WebFormShow(Sender: TObject);
begin
  lblConsultaTopo.Caption := 'Consulta de ' +  FTituloConsulta;
  lblSubConsulta.Caption := FTituloConsulta;
  FCdsConsulta := TXDataWebDataSet.Create(nil);
  FCdsConsulta.EntitySetName := FConsultaTabela;
  FCdsConsulta.Connection := DMConnection.ApiConnection;
  ConfigurarCds;
  FCdsConsulta.QueryTop := 5;
  FCdsConsulta.AfterOpen := cdsConsultaAfterOpen;
  FDtsConsulta := TDataSource.Create(nil);
  FDtsConsulta.DataSet := FCdsConsulta;
  tblConsulta.DataSource := FDtsConsulta;
  ConfigurarTabela;

  asm
    document.body.style.overflow = 'hidden';

    const spans = document.querySelectorAll('span');

    spans.forEach(span => {
    if (window.getComputedStyle(span).opacity === '0.2') {
    span.style.position = 'fixed';
    }
    });
  end;
end;

procedure TConsulta_Sistema.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblConsultaTopo := TLabel.Create('lblConsultaTopo');
  lblSubConsulta := TLabel.Create('lblSubConsulta');
  tblConsulta := TDBTableControl.Create('tblConsulta');
  edtConsulta := TEdit.Create('edtConsulta');
  btnFecharConsulta := TButton.Create('btnFecharConsulta');
  tmrConsulta := TTimer.Create(Self);

  lblConsultaTopo.BeforeLoadDFMValues;
  lblSubConsulta.BeforeLoadDFMValues;
  tblConsulta.BeforeLoadDFMValues;
  edtConsulta.BeforeLoadDFMValues;
  btnFecharConsulta.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'Consulta_Sistema';
    Width := 760;
    Height := 542;
    ElementPopupClassName := 'rounded-3 facil_bg_color_white';
    Visible := True;
    SetEvent(Self, 'OnCloseQuery', 'WebFormCloseQuery');
    SetEvent(Self, 'OnKeyDown', 'WebFormKeyDown');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblConsultaTopo.SetParentComponent(Self);
    lblConsultaTopo.Name := 'lblConsultaTopo';
    lblConsultaTopo.Left := 368;
    lblConsultaTopo.Top := 11;
    lblConsultaTopo.Width := 86;
    lblConsultaTopo.Height := 15;
    lblConsultaTopo.Caption := 'lblConsultaTopo';
    lblConsultaTopo.HeightPercent := 100.000000000000000000;
    lblConsultaTopo.WidthPercent := 100.000000000000000000;
    lblSubConsulta.SetParentComponent(Self);
    lblSubConsulta.Name := 'lblSubConsulta';
    lblSubConsulta.Left := 368;
    lblSubConsulta.Top := 32;
    lblSubConsulta.Width := 80;
    lblSubConsulta.Height := 15;
    lblSubConsulta.Caption := 'lblSubConsulta';
    lblSubConsulta.HeightPercent := 100.000000000000000000;
    lblSubConsulta.WidthPercent := 100.000000000000000000;
    tblConsulta.SetParentComponent(Self);
    tblConsulta.Name := 'tblConsulta';
    tblConsulta.Left := 20;
    tblConsulta.Top := 36;
    tblConsulta.Width := 300;
    tblConsulta.Height := 200;
    tblConsulta.BorderColor := clSilver;
    tblConsulta.ChildOrder := 6;
    tblConsulta.ElementTableClassName := 'table table-striped table-bordered table-hover';
    tblConsulta.Visible := False;
    SetEvent(tblConsulta, Self, 'OnClickCell', 'tblConsultaClickCell');
    SetEvent(tblConsulta, Self, 'OnGetCellData', 'tblConsultaGetCellData');
    SetEvent(tblConsulta, Self, 'OnGetCellClass', 'tblConsultaGetCellClass');
    edtConsulta.SetParentComponent(Self);
    edtConsulta.Name := 'edtConsulta';
    edtConsulta.Left := 20;
    edtConsulta.Top := 8;
    edtConsulta.Width := 300;
    edtConsulta.Height := 22;
    edtConsulta.ChildOrder := 7;
    edtConsulta.HeightPercent := 100.000000000000000000;
    edtConsulta.WidthPercent := 100.000000000000000000;
    SetEvent(edtConsulta, Self, 'OnKeyDown', 'edtConsultaKeyDown');
    SetEvent(edtConsulta, Self, 'OnKeyUp', 'edtConsultaKeyUp');
    btnFecharConsulta.SetParentComponent(Self);
    btnFecharConsulta.Name := 'btnFecharConsulta';
    btnFecharConsulta.Left := 368;
    btnFecharConsulta.Top := 53;
    btnFecharConsulta.Width := 96;
    btnFecharConsulta.Height := 25;
    btnFecharConsulta.Caption := 'X';
    btnFecharConsulta.ChildOrder := 4;
    btnFecharConsulta.HeightPercent := 100.000000000000000000;
    btnFecharConsulta.WidthPercent := 100.000000000000000000;
    SetEvent(btnFecharConsulta, Self, 'OnClick', 'btnFecharConsultaClick');
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 192;
    tmrConsulta.Top := 264;
  finally
    lblConsultaTopo.AfterLoadDFMValues;
    lblSubConsulta.AfterLoadDFMValues;
    tblConsulta.AfterLoadDFMValues;
    edtConsulta.AfterLoadDFMValues;
    btnFecharConsulta.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.